/**
 * cart-shipping-tooltip.js — tap-to-toggle for the shipping-rates info icon in the
 * free-shipping box (snippets/cart-free-shipping.liquid, summary layout), used by both
 * the cart page and the cart drawer. Hover / focus is pure CSS; this adds tap (iOS
 * doesn't focus buttons on tap) plus outside-click and Escape to close. Delegated on
 * document so it survives the AJAX re-renders, and guarded so loading it from both
 * surfaces on the same page binds once.
 */
(function () {
  if (window.__mfCartShippingTooltipBound) return;
  window.__mfCartShippingTooltipBound = true;

  function closeTips(except) {
    document.querySelectorAll('[data-shipping-info].is-open').forEach(function (wrap) {
      if (wrap === except) return;
      wrap.classList.remove('is-open');
      var b = wrap.querySelector('[data-shipping-info-btn]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-shipping-info-btn]') : null;
    var wrap = btn ? btn.closest('[data-shipping-info]') : null;
    closeTips(wrap);
    if (!wrap) return;
    var open = wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') closeTips();
  });
})();
